/**
 * apiCall — Phase D split (Feb 2026).
 *
 * Extracted verbatim from `useStore.js`. This is the single store-level
 * fetch helper used by `createAuthSlice` (signIn / signUp / refresh-me)
 * and any future slice that needs a token-aware fetch.
 *
 * Behavior is byte-identical to the original inline declaration:
 *   - reads `eoc-auth-token` from localStorage
 *   - merges `Content-Type: application/json` + Bearer token + caller headers
 *   - prefixes `endpoint` with `process.env.REACT_APP_BACKEND_URL || ''`
 *   - throws `new Error(detail || 'Request failed')` on non-2xx
 *
 * Kept here (not in `core/env.js` or `services/api.js`) because the
 * store specifically needs an error-throwing flavour that bypasses
 * the central `services/api.js` layered helpers.
 */
const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const apiCall = async (endpoint, options = {}) => {
  const token = localStorage.getItem('eoc-auth-token');
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Request failed' }));
    throw new Error(error.detail || 'Request failed');
  }

  return response.json();
};
